export default __webpack_public_path__ + "static/media/1_0024.2d69cbfd.webp";